import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';
import { auth as sharedAuth, setToken as setSharedToken } from '@/api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('r2yn_token');
    const savedUser = localStorage.getItem('r2yn_user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        localStorage.removeItem('r2yn_token');
        localStorage.removeItem('r2yn_user');
      }
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    // Login to LOCAL backend first
    const res = await api.post('/auth/login', { email, password });
    const { access_token, user: userData } = res.data;
    localStorage.setItem('r2yn_token', access_token);
    localStorage.setItem('r2yn_user', JSON.stringify(userData));
    setUser(userData);
    
    // ALSO login to SHARED backend to get shared token for integrations vault
    try {
      const sharedData = await sharedAuth.login(email, password);
      console.log('[Auth] ✓ Dual authentication successful - both local and shared tokens stored');
    } catch (err) {
      console.warn('[Auth] ⚠️ Shared backend login failed:', err.message, '- Integrations vault may not work');
    }
    
    return userData;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post('/auth/logout');
    } catch {}
    
    // Clear both local and shared tokens
    localStorage.removeItem('r2yn_token');
    localStorage.removeItem('r2yn_user');
    sharedAuth.logout();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
